

import React, { useMemo } from 'react';

import styled from 'styled-components';
import Mustache from 'mustache';

import { purifyHTML } from '../../../../common/utils';

import { useDataContext } from '../../contexts/DataAdapterContext';












const shared = `
  width: 100%;
  height: inherit;
  position: absolute;
  object-fit: cover;
  z-index: 0;
  mix-blend-mode: soft-light;
`;

const TextBackgroundImage = styled.img`${shared}`;

const TextBackgroundVideo = styled.video`${shared}`;

const TextBase = styled.p.attrs((props) => ({
  style: { ...props.style, ...props.conditionalStyle }
}))`${(props) => props.computedStyle}`;

const Text = (props) => {
  const { title, style, computedStyle } = props;
  const { text = '', className = '', imageSource, videoSource } = title;
  const { replaceVariables } = useDataContext();

  const replacedText = useMemo(() => {
    const breakText = text.replace(/(?:\r\n|\r|\n)/g, '<br/>');

    if (!replaceVariables) {
      return breakText;
    }

    try {
      const mustacheTemplate = breakText.replace(/\$\{(\w+)\}/g, '{{$1}}');
      return Mustache.render(mustacheTemplate, replaceVariables);
    } catch (e) {
      console.error(e);
      return breakText;
    }
  }, [text, replaceVariables]);

  return (
    <>
      {imageSource && <TextBackgroundImage src={imageSource} alt="default" />}
      {videoSource &&
      <TextBackgroundVideo loop muted autoPlay>
        <source src={videoSource} />
      </TextBackgroundVideo>}

      <TextBase
        className={className}
        style={style}
        computedStyle={computedStyle}
        conditionalStyle={imageSource || videoSource ? {
          position: 'relative',
          display: 'grid',
          height: '100%',
          placeItems: 'center'
        } : {}}
        dangerouslySetInnerHTML={{ __html: purifyHTML(replacedText) }} />

    </>);

};

export default Text;